import {serverCall} from "@/redux/apis/http";
import {UPDATE_STATUS} from "@/redux/rtk/admin/classes/types";
import {CREATE_CYCLE_FIELDS, CYCLES_FILTER, EDIT_CYCLE_SCHEDULE} from "@/app/admin/cycles/page";
import {CREATE_EDIT_SCHEDULE, SCHEDULE_FILTER} from "@/app/admin/cycles/schedules/[cycleId]/page";
import {STUDENT_REGISTRATION_FILTERS} from "@/app/admin/cycles/studentRegistrations/page";
import {
    ImageUploadRequest,
    TEMPLATE_PROPS,
    UPDATE_USER_REGISTRATION
} from "@/app/students/registrations/[cycleId]/page";
import {REGISTRATION_STATUS} from "@/app/admin/cycles/studentRegistrations/[registrationId]/changeStatusDialog";

export const getClassesForCycles = async () => {
    return await serverCall({
        type: "get",
        timeout: 1,
        endpoint: "/getClassesForCycles",
        apiDir: `webapi/shared`,
    }, null)
}

export const createNewCycle = async (data: CREATE_CYCLE_FIELDS) => {
    return await serverCall({
        type: "post",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/createNewCycle",
        apiDir: `webapi/shared`,
    }, null)
}

export const getCycles = async (data: CYCLES_FILTER) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
          ...data
        },
        endpoint: "/getCycles",
        apiDir: `webapi/shared`,
    }, null)
}

export const updateCycleStatus = async (data: UPDATE_STATUS) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/updateCycleStatus",
        apiDir: `webapi/shared`,
    }, null)
}

export const deleteCycle = async (data: {uid: number}) => {
    return await serverCall({
        type: "delete",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/markClassAsDeleted",
        apiDir: `webapi/shared`,
    }, null)
}

export const getCycleDetails = async (data: {uid: number}) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            ...data,
            customQueryFile: "cycles"
        },
        endpoint: "/getCycleDetails",
        apiDir: `webapi/shared`,
    }, null)
}

export const updateCycleDetails = async (data: CREATE_CYCLE_FIELDS) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/updateCycleDetails",
        apiDir: `webapi/shared`,
    }, null)
}

export const getCenters = async (uid: number) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
          uid
        },
        endpoint: "/getCenters",
        apiDir: `webapi/shared`,
    }, null)
}

export const getSchedules = async (data: SCHEDULE_FILTER) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/getSchedules",
        apiDir: `webapi/shared`,
    }, null)
}

export const addNewSchedule = async (data: CREATE_EDIT_SCHEDULE) => {
    return await serverCall({
        type: "post",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/addNewSchedule",
        apiDir: `webapi/shared`,
    }, null)
}

export const updateSchedule = async (data: CREATE_EDIT_SCHEDULE) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/updateSchedule",
        apiDir: `webapi/shared`,
    }, null)
}

export const updateScheduleStatus = async (data: UPDATE_STATUS) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/updateScheduleStatus",
        apiDir: `webapi/shared`,
    }, null)
}

export const getRegistrations = async (data: STUDENT_REGISTRATION_FILTERS) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            ...data,
            classId_optional: data.classId,
            cycleId_optional: data.cycleId,
            centerId_optional: data.centerId,
            categoryId_optional: data.categoryId
        },
        endpoint: "/getRegistrations",
        apiDir: `webapi/shared`,
    }, null)
}

export const generateRegistrationsReport = async (data: STUDENT_REGISTRATION_FILTERS) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            ...data,
            classId_optional: data.classId,
            cycleId_optional: data.cycleId,
            centerId_optional: data.centerId,
            categoryId_optional: data.categoryId
        },
        endpoint: "/generateRegistrationsReport",
        apiDir: `webapi/shared`,
    }, null)
}

export const getRegistrationDetails = async (uid: number) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            uid
        },
        endpoint: "/getRegistrationDetails",
        apiDir: `webapi/shared`,
    }, null)
}

export const admin_printChallanForm = async (data: TEMPLATE_PROPS) => {
    return await serverCall({
        type: "post",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/admin_printChallanForm",
        apiDir: `webapi/shared`,
    }, null)
}

export const admin_printSlip = async (data: TEMPLATE_PROPS) => {
    return await serverCall({
        type: "post",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/admin_printSlip",
        apiDir: `webapi/shared`,
    }, null)
}

export const admin_updateRegistrationImage = async (data: ImageUploadRequest) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data.data
        },
        files: data.files,
        fileUpload: true,
        endpoint:  `/admin_updateRegistrationImage`,
        apiDir: `webapi/shared`,
    }, data.onProgress)
}

export const admin_saveRegistration = async (data: UPDATE_USER_REGISTRATION) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/admin_saveRegistration",
        apiDir: `webapi/shared`,
    }, null)
}

export const admin_updateRegistrationStatus = async (data: REGISTRATION_STATUS) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data,
            bankDetails: JSON.stringify({
                bankName: data.bankName ?? "",
                bankAccount: data.bankAccount ?? "",
                bankBranchCode: data.bankBranchCode ?? ""
            })
        },
        endpoint: "/admin_updateRegistrationStatus",
        apiDir: `webapi/shared`,
    }, null)
}

export const admin_processPendingPayment = async (data: REGISTRATION_STATUS) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data,
            bankDetails: JSON.stringify({
                bankName: data.bankName ?? "",
                bankAccount: data.bankAccount ?? "",
                bankBranchCode: data.bankBranchCode ?? ""
            })
        },
        endpoint: "/admin_processPendingPayment",
        apiDir: `webapi/shared`,
    }, null)
}

export const editCycleSchedule = async (data: EDIT_CYCLE_SCHEDULE) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/editCycleSchedule",
        apiDir: `webapi/shared`,
    }, null)
}

